import React, {Component} from 'react';
import {connect} from 'react-redux';
import { injectIntl } from 'react-intl';
import {bindActionCreators} from 'redux';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import * as userActsions from '../actions/userActions';
import Resource from "../services/PrivateAPIResource"
import {toastrErrorHandler} from "../actions/utils";
import * as analyticOptions from "./analytics/analyticOptions";

class DemoModeTopbar extends Component {
    constructor(props) {
        super(props);

        this.loginAsAdmin = this.loginAsAdmin.bind(this);
    }

    componentDidMount() {
        this.props.actions.getDemoAdminUser();
    }

    loginAsAdmin() {
        // cache the statistics filter dates (in cookies), but change the company to default
        let cachedFilter = analyticOptions.getCachedFilter();

        if (cachedFilter) {
            cachedFilter.companyId = 1;
            analyticOptions.cacheFilterValues(cachedFilter, ['startDate', 'endDate', 'groupBy', 'type', 'companyId']);
        }

        Resource.create(`global-users/login-as-webmaster`, new FormData(), true)
            .then(() => {
                this.props.actions.getCurrentUser();
                this.props.actions.getDemoAdminUser();
                this.context.router.history.push('/virksomhed');
            })
            .catch(toastrErrorHandler);
    }

    render() {
        const {demoAdminUser} = this.props;
        if(!demoAdminUser) {
            return null;
        }

        return (
            <div className="demo-mode-topbar">
                <div className="attempt-message pull-left">
                    <h5>
                        <FormattedMessage
                            id="demoModeTopbar.attemptMessage"
                            defaultMessage="You have been authorized on behalf of"
                        /> {demoAdminUser.name}
                    </h5>
                </div>
                <div className="action-container pull-right">
                    <button
                        className="btn btn-secondary waves-effect waves-light pull-right recover-webmaster-button"
                        onClick={this.loginAsAdmin}
                    >
                        <FormattedMessage
                            id="demoModeTopbar.recoverSession"
                            defaultMessage="Recover Webmaster session"
                        />
                    </button>
                </div>
                <div className="clearfix"></div>
            </div>

        );
    }
}

DemoModeTopbar.contextTypes = {
    router: PropTypes.object.isRequired,
};


function mapStateToProps(state, ownProps) {
    return {
        demoAdminUser: state.demoAdminUser
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(
            Object.assign(
                {},
                userActsions
            ), dispatch
        )
    }

}

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(DemoModeTopbar));


// WEBPACK FOOTER //
// ./web/src/components/DemoModeTopbar.jsx